module.exports = __webpack_public_path__ + "img/dominant_back1.b06fc49f.png";